<div style="display: none; z-index: -3;">
  <img src="/assets/img/rota-background-big-blur.jpg" alt="">
</div>
<div class="font-preload">
  <p style="font-weight: 100;"></p>
  <p style="font-weight: 200;"></p>
  <p style="font-weight: 300;"></p>
  <p style="font-weight: 400;"></p>
  <p style="font-weight: 500;"></p>
  <p style="font-weight: 600;"></p>
  <p style="font-weight: 700;"></p>
  <p style="font-weight: 800;"></p>
  <p style="font-weight: 900;"></p>
  <p style="font-weight: normal;"></p>
  <p style="font-weight: lighter;"></p>
  <p style="font-weight: bolder;"></p>
</div>
